// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3jcJB","validationTips":"StatementDescriptor_validationTips__3SmlJ"};